"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var usefulnessScale = ["Not at all useful", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Extremely useful"];
var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var questions = screenersImport.expandscreeners([{
  prompt: "This post-program assessment is similar to the one you completed at the " + "beginning of the program. It takes 5 minutes to complete, and will allow you " + "to compare your results before and after participating in Uprise. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party. We hope you enjoyed the program!",
  type: "multi",
  options: {
    options: [],
    reversed: false
  },
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, utils.screeners.PSS4, utils.screeners.ROI_HPQ_3_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE, utils.screeners.ORS, utils.screeners.WHO5, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsWork",
  eval: likelihoodFn,
  batteryId: "survey"
}, // Company support and cohesion
{
  prompt: "In the past week, to what extent have you felt supported by " + "your company?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "companySupport",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "In the past week, how united has your team been in trying to " + "reach its goals for performance?",
  extraText: "",
  type: "slider",
  options: ["Not at all united", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely united"],
  key: "cohesion",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // Sleep
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "slider",
  options: ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"],
  key: "sleepQuality",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // NPS - Uprise
{
  prompt: "How likely would you be to recommend the Uprise program to a " + "colleague or friend?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsUprise",
  eval: likelihoodFn,
  batteryId: "survey"
}, {
  prompt: "In one sentence, how would you describe the Uprise program to " + "a colleague or friend?",
  extraText: "",
  type: "single",
  optional: false,
  key: "oneSentence",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, // Program evaluation, phrased in a way to encourage reflection
{
  prompt: "How would you rate module 1 (retraining thoughts)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod1_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 2 (work-life balance)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod2_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 3 (mindfulness)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod3_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 4 (perspective taking)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod4_PT_rating",
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How useful did you find the coaching calls?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, // Feedback and Referral
{
  prompt: "If you had a magic wand and could change one thing about the " + "program, what would it be?",
  extraText: "",
  type: "single",
  optional: true,
  batteryId: "survey",
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "Would you be willing to give some brief feedback via the phone " + "following the completion of the program?",
  extraText: "",
  type: "multi",
  key: "feedback",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  options: ["Yes", "No"],
  batteryId: "survey"
}, {
  prompt: "If you could recommend Uprise to one colleague or family " + "member who we will contact via email, who would that be?",
  extraText: "",
  type: "single",
  optional: true,
  key: "referral",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "If you would like to share your experience of Uprise with " + "potential future users, please leave a testimonial here.",
  extraText: "",
  type: "single",
  optional: true,
  key: "testimonial",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]);

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  results.humanReadable = {};
  [utils.screeners.PSS4, utils.screeners.ROI_HPQ_3_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE, utils.screeners.ORS, utils.screeners.WHO5].forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i], q);
    results.humanReadable[q.prompt] = q.eval(answers[i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};